class CollectionPerRow {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._collectionGrid = document.querySelector('[data-collection-grid]')
    }
    onInit () {
        if (!localStorage.perRow) {
            localStorage.setItem('perRow', '3')
        }
        let perRow = localStorage.perRow || '3'
        if (perRow === '3') {
            this._collectionGrid.classList.remove('collection-grid--4')
            this._collectionGrid.classList.add('collection-grid--3')
        } else if (perRow === '4') {
            this._collectionGrid.classList.remove('collection-grid--3')
            this._collectionGrid.classList.add('collection-grid--4')
        }

        const controls = this._elem.querySelectorAll('[data-per-row-control]')
        if (controls.length > 0) {
            for (let control of controls) {
                control.addEventListener('click', (e) => { e.preventDefault(); this.changeRows(e) })
            }
        }
    }

    changeRows (e) {
        let num = e.currentTarget.dataset.perRowControl
        if (num) {
            if (num === '3') {
                this._collectionGrid.classList.remove('collection-grid--4')
                this._collectionGrid.classList.add('collection-grid--3')
            } else if (num === '4') {
                this._collectionGrid.classList.remove('collection-grid--3')
                this._collectionGrid.classList.add('collection-grid--4')
            }
            localStorage.setItem('perRow', num)
        }
    }
}

export default CollectionPerRow



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionPerRow.js